export enum ContactUsStatus {
  WAITING = 1,
  ANSWERED = 2,
}
export const getContactUsStatus = (status: ContactUsStatus) => {
  switch (status) {
    case ContactUsStatus.WAITING:
      return "waiting";
    case ContactUsStatus.ANSWERED:
      return "answered";
    default:
      return "waiting";
  }
};
export const getContactUsStatusColors = (status: ContactUsStatus) => {
  switch (status) {
    case ContactUsStatus.WAITING:
      return "warning";
    case ContactUsStatus.ANSWERED:
      return "success";
    default:
      return "warning";
  }
};